module.exports = __webpack_public_path__ + "img/reddit-r-all.5304bc22.png";